document.addEventListener('DOMContentLoaded', () => {
  const hero = document.querySelector('[data-els-home-hero]');
  const menu = document.getElementById('heroMenu');

  if (!hero || !menu) return;

  const compactViewport = window.matchMedia('(max-width: 749px)');
  const HIDE_AFTER = 180;
  const DELTA = 14;
  let lastY = window.scrollY || 0;
  let ticking = false;

  function syncMenuVisibility() {
    if (compactViewport.matches) {
      menu.classList.remove('is-hidden');
      lastY = window.scrollY || 0;
      ticking = false;
      return;
    }

    const y = window.scrollY || 0;
    const diff = y - lastY;

    if (y <= HIDE_AFTER) {
      menu.classList.remove('is-hidden');
    } else if (Math.abs(diff) > DELTA) {
      menu.classList.toggle('is-hidden', diff > 0);
    }

    lastY = y;
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    () => {
      if (compactViewport.matches) return;
      if (!ticking) {
        window.requestAnimationFrame(syncMenuVisibility);
        ticking = true;
      }
    },
    { passive: true }
  );

  if (typeof compactViewport.addEventListener === 'function') {
    compactViewport.addEventListener('change', syncMenuVisibility);
  } else if (typeof compactViewport.addListener === 'function') {
    compactViewport.addListener(syncMenuVisibility);
  }

  syncMenuVisibility();
});
